import { getPath } from '@/router/common'
const baseUrl = {
  title: 'chart图表',
  path: 'NewChart'
}

export default [
  {
    path: getPath('OrderNumChart', baseUrl),
    name: 'orderNumChart',
    component: () => import( /* webpackChunkName: "OrderNumChart" */ '@/views/newChart/orderNumChart/index.vue' ),
    meta: {
      title: '单量业务趋势图'
    }
  },
  {
    path: getPath('CarChart', baseUrl),
    name: 'carChart',
    component: () => import( /* webpackChunkName: "CarChart" */ '@/views/newChart/carChart/index.vue' ),
    meta: {
      title: '在途车辆分布图'
    }
  }
]
